import {
  DateRangePickerPresetKey,
  getDateRangePickerPresetValue,
  type DateRangePickerValue,
} from '@shigo-ui/ui';

export function analyticsMaxDate(now = new Date()) {
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

export function analyticsPresetRange(
  preset: DateRangePickerPresetKey,
  now = new Date(),
): DateRangePickerValue {
  const value = getDateRangePickerPresetValue(preset, now, { endPeriodsYesterday: true });
  if (value.dateFrom > value.dateTo)
    return analyticsPresetRange(DateRangePickerPresetKey.Yesterday, now);
  return { ...value, preset };
}

export function normalizeAnalyticsRange(
  value: DateRangePickerValue,
  now = new Date(),
): DateRangePickerValue {
  if (value.preset === DateRangePickerPresetKey.Today)
    return analyticsPresetRange(DateRangePickerPresetKey.Today, now);
  const today = analyticsPresetRange(DateRangePickerPresetKey.Today, now);
  if (value.dateFrom > today.dateTo) return today;
  if (value.dateTo > today.dateTo) return { dateFrom: value.dateFrom, dateTo: today.dateTo };
  return value;
}

// These backend presets include today and override explicit dates.
export function requiresExplicitAnalyticsDates(preset: string | null | undefined) {
  return (
    preset === DateRangePickerPresetKey.ThisWeek ||
    preset === DateRangePickerPresetKey.ThisMonth ||
    preset === DateRangePickerPresetKey.ThisYear
  );
}
